import { getConfigBooleanValue } from '@showclix-shared-util/configClient';

export const isListingMonetizationAEnabled = (defaultValue = false) => {
  return getConfigBooleanValue('ListingMonetizationCheckoutA', defaultValue);
}
